import cartFields from './cartFields.fragment'

/** GraphQL Mutation that adds a product to the cart */
export default `
  mutation addProductsToCart($cartId: String!, $cartItems: [CartItemInput!]!) {
    addProductsToCart(cartId: $cartId, cartItems: $cartItems) {
      cart {
        ${cartFields}
      }
    }
  }
`
